export const GERMAN_TRANSLATIONS = {
  text: {
    web_title: 'SMARTZ®-DASHBOARD',
    authentication: 'Authentifizierung',
    username: 'Benutzername',
    password: 'Passwort',
    sign_in: 'Anmelden',
    username_required: 'Benutzername ist erforderlich',
    password_required: 'Passwort ist erforderlich',
    invalid_credential: 'Falscher Benutzername oder falsches Passwort',
    forgot_password: 'Passwort vergessen',
    change: 'Änderung',
    well_being: 'Wohlbefinden',
    warnings: 'Warnungen',
    no_patients_to_change: 'Keine Patienten zum Wechseln',
    no_patients: 'Keine Patienten',
    logout: 'Abmelden',
    lost_connection: 'Verbindung mit Smartz®-Cloud verloren',
    check_connection: 'Bitte überprüfen Sie Ihre Internetverbindung',
    trying_to_reconnect: 'Es wird versucht, die Verbindung wiederherzustellen',
    pad_time: 'Zeit im IKM',
    red_time: 'Zeit in Rot',
    position: 'Position',
    time: 'Zeit',
    time_in_position: 'Zeit in Position',
    sitting: 'Sitzend',
    standing: 'Stehend',
    left: 'Links',
    right: 'Rechts',
    lying: 'Liegend',
    unknown: 'Unbekannt',
    wet_surface: 'Nasse Oberfläche',
    out_of_range: 'Außerhalb des Bereichs',
    low_battery: 'Niedriger Batteriestand',
    disconnected: 'Getrennt',
    unexpected_problem: 'Unerwartetes Problem',
    ok: 'Okay',
    change_soon: 'Demnächst wechseln',
    change_pad: 'IKM wechseln',
    languages: 'Sprachen',
    dashboard: 'DASHBOARD',
    pad_fill_profile: '{pad}-Füllstandprofil',
    goal: 'ZIELVORGABEN',
    report: 'BERICHT',
    manage: 'VERWALTEN',
    individual: 'Individuell',
    group: 'Gruppe',
    action_required: 'MAẞNAHME ERFORDERLICH',
    monitor: 'MONITORING',
    pod_unclipped: 'IKM nicht angebracht',
    check_patient: '{patient} überprüfen',
    check_pad: 'IKM überprüfen',
    check_time_in_pad: 'Zeit im IKM überprüfen',
    check_position: 'Position überprüfen',
    check_temperture: 'Temperatur messen',
    check_pad_fill_profile: '{ikm}-FÜLLSTANDPROFIL ÜBERPRÜFEN',
    instructions: 'Anleitung',
    time_in_pos: 'Zeit in Position',
    pad_capacity: '{pad}-Kapazität',
    time_in_pad: 'Zeit im IKM',
    ambient: 'Umgebung',
    time_at_temp: 'Zeit bei Temperatur',
    pad_wet: 'IKM NASS',
    pad_dry: 'IKM TROCKEN',
    daily_pad_fill: 'Tägliche IKM-Füllung',
    seven_day_trend: 'Sieben-Tage-Trend',
    daytime: 'Tageszeit',
    nighttime: 'Nachtzeit',
    volume_in_pad: 'Volumen im IKM',
    pad_fill_summary: 'ÜBERSICHT ÜBER DIE IKM-FÜLLUNG',
    daily_average: 'Täglicher Durchschnitt',
    today: 'Heute',
    capacity: 'Kapazität',
    pads_used: 'Benutzte IKM',
    per_day: 'pro Tag',
    average: 'Durchschnitt',
    leakage_detected: 'Auslaufen erkannt',
    times: 'Zeiten',
    pad_cycles: 'IKM-Zyklen',
    time_in_a_pos: 'Zeit in einer Position',
    max_time_in_a_pos: 'Maximale Zeit in Position',
    re_positioning: 'Neupositionierung',
    time_day: 'Uhrzeit/Tag',
    temperature: 'Temperatur',
    typical_temp: 'Typische Temperatur',
    temp_range: 'Temperaturbereich',
    charts: 'BERICHTE',
    pad_fill_profile_for_7_days: 'IKM-Füllprofil – Sieben-Tage-Trend',
    daily_total: 'Gesamt täglich',
    accuracy: 'Genauigkeit',
    last_24_hours: '24 Stunden ab dem ausgewählten Datum',
    volume_voided_in_pad: 'Im IKM entleertes Volumen',
    body: 'Körper',
    wetness_usage: 'Nässe/Verwendung',
    environment_body: 'Umgebungstemperatur',
    activity: 'Aktivität',
    lift_style: 'Art des Anhebens',
    skin_care: 'IKM Tragedauer',
    skin_care_management: 'IKM Tragedauer-Management',
    workflow: 'Workflow',
    workflow_efficiency: 'Workflow-Effizienz',
    set_maximum_voiding_volume_into_pad:
      'Maximales Entleerungsvolumen im IKM festlegen',
    less_void: 'WENIGER ENTLEERUNG',
    more_void: 'MEHR ENTLEERUNG',
    day: 'TAG',
    night: 'NACHT',
    day_time: 'Tageszeit',
    night_time: 'Nachtzeit',
    average_period: 'Durchschnittlicher Zeitraum',
    default: 'STANDARD',
    desire_position: 'Zeit in Position',
    time_in_a_position: 'Zeit in einer Position',
    desire_temperature: 'Umgebungstemperatur des Pods',
    coloer: 'KÄLTER',
    hotter: 'HEIẞER',
    desire_skin_care: 'IKM Tragedauer',
    off: 'AUS',
    standard_care: 'STANDARDPFLEGE',
    extra_care: 'ZUSÄTZLICHE PFLEGE',
    more_time_in_wet_pad: 'MEHR ZEIT IM NASSEN IKM',
    more_time_in_a_pos: 'MEHR ZEIT IN EINER POSITION',
    less_time_in_wet_pad: 'WENIGER ZEIT IM NASSEN IKM',
    less_time_in_a_pos: 'WENIGER ZEIT IN EINER POSITION',
    override:
      'Diese Vorgabe setzt die Zielvorgaben für das IKM und den Körper außer Kraft',
    check_pod: 'Pod überprüfen',
    check_pod_and_reclip: 'Pod überprüfen und erneut anbringen',
    lost_connect: 'Verbindung verloren',
    voids_into_pad_hours: 'Entleert sich in 96 Stunden in das IKM',
    chart_date: 'Datum des Diagramms',
    fullscreen: 'Vollbild',
    normalscreen: 'Normale Ansicht',
    void_chart: 'Miktionsprotokoll',
    voids_into_pad: 'Entleerungen in das IKM',
    pad_fill_trend: 'IKM-Fülltrend',
    legend: 'LEGENDE',
    new_pad: 'Neues IKM',
    void_in_pad: 'Entleerung in das IKM',
    share: 'Teilen',
    print: 'Drucken',
    position_profile: 'Positionsprofil',
    body_position: 'Körperposition',
    body_positions_over_96_hours: 'Körperpositionen über 96 Stunden',
    lying_on_back: 'Liegend – auf dem Rücken',
    lying_on_front: 'Liegend – auf dem Bauch',
    lying_left_side: 'Liegend – auf der linken Seite',
    lying_right_side: 'Liegend – auf der rechten Seite',
    standing_walking: 'Stehend/Gehend',
    stats: 'Statistiken',
    pad_used: 'IKM_benutzt',
    max: 'Max.',
    surrounding_temperature: 'UMGEBUNGSTEMPERATUR',
    temp: 'Temperatur',
    avg: 'Durchschnitt',
    name: 'Name',
    provider: 'Anbieter',
    purpose: 'Zweck',
    expiry: 'Ablaufdatum',
    type: 'Typ',
    frequently_asked_questions: 'Häufig gestellte Fragen (FAQ)',
    information_for_use: 'Anwendungsinformationen',
    data_privacy: 'Datenschutz',
    eula: 'EULA',
    about: 'Über uns',
    settings: 'Einstellungen',
    save: 'Speichern',
    version: 'Version',
    support: 'Support',
    close: 'Schließen',
    copyright:
      'Copyright (C) 2022 Smartz Operations Limited. Alle Rechte vorbehalten',
    smartz_devices: 'Smartz®-Geräte',
    monitor_smartz_device_operation: 'Smartz®-Gerätebetrieb überwachen',
    last_seen: 'Zuletzt gesehen',
    battery: 'Batterie',
    ago: 'vor',
    date_rate: 'Stichtag',
    online: 'Online',
    singnal: 'Signal',
    temperature_goal: 'TEMPERATURVORGABE',
    data_privacy_desc: 'Einwilligung und personenbezogene Daten verwalten',
    organisation: 'ORGANISATION',
    organisation_desc: 'Gruppeneinstellungen verwalten',
    my_account: 'Mein Konto',
    my_account_desc: 'Kontoeinstellungen verwalten',
    consent: 'Einwilligung',
    marketing_comm: 'Marketing, Kommunikation und Werbeaktionen',
    consent_desc:
      'IKM-Hersteller und -Vertreiber können personenbezogene Daten für Marketing- und Werbezwecke verwenden. Das/die mit diesem Patienten verbundene(n) Benutzerkonto/Benutzerkonten kann/können mitunter per E-Mail gesendet werden. In diesem Fall kann die E-Mail-Adresse des Benutzers an Dritte weitergegeben werden.',
    data_management: 'Datenmanagement',
    Permanently_delete_account: 'Dieses Benutzerkonto endgültig löschen',
    permanently_delete_client: 'Diesen Client endgültig löschen',
    data_management_desc:
      'Das Konto ist nicht mehr verfügbar, und alle Daten im Konto werden endgültig gelöscht.',
    how_can_i_export:
      'Wie kann ich meine Kontoinformationen exportieren und sichern?',
    save_preference: 'EINSTELLUNG SPEICHERN',
    delete_account_data: 'KONTO UND DATEN LÖSCHEN',
    date_time_settings: 'Einstellungen von Datum und Uhrzeit',
    morning_time: 'Vormittags',
    night_time_label: 'Nachts',
    time_format: 'Zeitformat',
    date_format: 'Datumsformat',
    goal_text: 'Vorgabe',
    day_goal: 'Vorgabe für den Tag',
    night_goal: 'Vorgabe für die Nacht',
    productivity: 'Produktivität',
    productivity_goal: 'Produktivitätsvorgabe',
    score: 'Wert',
    presently: 'Derzeit',
    diapers_per_person: '{pads}/Person',
    diapers_per_person_daytime: '{pads}/Person/Tagsüber',
    diapers_per_person_night: '{pads}/Person/Nachts',
    diapers_per_person_day: '{pads}/Person/Tag',
    check_battery: 'BATTERIE ÜBERPRÜFEN',
    reminders: 'Erinnerungen',
    update_data_privacy_consent:
      'Einwilligung zur Datenschutzerklärung aktualisieren',
    update: 'Aktualisieren',
    user: 'Benutzer',
    last_updated: 'Zuletzt aktualisiert',
    action: 'Maßnahme',
    delete_confirm: 'Möchten Sie das wirklich löschen?',
    cancel: 'Abbrechen',
    lost_internet_connection: 'INTERNETVERBINDUNG VERLOREN',
    check_setting:
      'Bitte überprüfen Sie Ihre Interneteinstellungen und -verbindungen',
    authentication_required: 'Authentifizierung erforderlich',
    account_details_have_changed: 'Kontoangaben haben sich geändert',
    date: 'Datum',
    no_pod_assigned: 'Kein Pod zugewiesen',
    monitoring_is_not:
      'Monitoring ist nicht verfügbar, da kein Smartz®-Pod zugewiesen wurde ',
    assign_a_pod: 'Zuweisen eines Pods zur',
    on_the_smartz_monitor_app:
      'Smartz®-Monitoring-App, um die Monitoring zu aktivieren.',
    see: 'Siehe',
    delete: 'Löschen',
    keep_in_mind_delete_data:
      'Bitte beachten Sie, dass das Löschen des Benutzerkontos und der personenbezogenen Daten endgültig ist.',
    you_able_to_delete_data: 'Sie sind dabei,',
    account_and_data: 'dieses Konto und die Daten',
    this: ' zu löschen',
    average_time_in_pad: 'Durchschnittliche Zeit im {pad}',
    average_time_in_position: 'Durchschnittliche Zeit in Position',
    repositioning_24h: 'Neupositionierung 24 h',
    last_7_day_period: 'Letzter 7-Tage-Zeitraum',
    admin: 'ADMIN',
    administraive_settings: 'Administrative Einstellungen',
    group_data_rentenion: 'Aufbewahrung von Gruppendaten',
    maximum_inactivity_data_retention_period:
      'Maximale Aufbewahrungsfrist für inaktive Daten',
    group_data_rentenion_desc:
      'Personenbezogene Daten aller Benutzer und {patients} innerhalb dieser Gruppe werden entfernt, wenn der Inaktivitätszeitraum erreicht wurde.',
    data_rentenion_detail:
      'Die Bedingung für Inaktivität lautet wie folgt:<br>- Der Pod ist dem {patient} für einen bestimmten Zeitraum nicht zugewiesen.<br>- Der Pod ist dem {patient} zugewiesen, überträgt aber für einen bestimmten Zeitraum keine Daten an Smartz® -Apps.<br>- Der Benutzer hat sich für einen bestimmten Zeitraum nicht angemeldet.',
    months: 'Monate',
    user_roles: 'Benutzerrollen',
    users: 'Benutzer',
    role: 'Rolle',
    filter_by_group_or_users: 'nach Gruppe oder Benutzern filtern',
    urine_conversion_feature: 'Urin-Umwandlungsfunktion',
    use_urine_transform: 'Urintransformation verwenden',
    system_data_rentenion: 'Aufbewahrung von Systemdaten',
    system_data_rentenion_desc:
      'Personenbezogene Daten aller Benutzer und {patients} innerhalb dieses Systems werden entfernt, wenn der Inaktivitätszeitraum erreicht wurde.',
    reset_password: 'Passwort zurücksetzen',
    new_password: 'Neues Passwort',
    confirm_password: 'Passwort bestätigen',
    password_inconsistent: 'Das Passwort ist unstimmig',
    edit: 'bearbeiten',
    edit_roles: 'Rolle bearbeiten',
    available_roles: 'Verfügbare Rollen',
    assigned_roles: 'Zugewiesene Rollen',
    role_list: 'Liste der Rollen',
    role_name: 'Bezeichnung der Rolle',
    role_permissions: 'Berechtigung der Rolle',
    level_1_module: 'Level 1 Modul',
    level_2_module: 'Level 2 Modul',
    permissions: 'Berechtigungen',
    add_role: 'ROLLE HINZUFÜGEN',
    roles: 'Rollen',
    role_settings: 'Rolleneinstellungen',
    edit_role: 'Rolle bearbeiten',
    account_take_effect:
      'Die Aktualisierung wird nach der erneuten Anmeldung wirksam.',
    algorithms: 'Algorithmen',
    delete_role_confirm: 'Das Löschen der Rolle ist endgültig.',
    //translate permissions list
    'Dashboard Module': 'Modul Dashboard',
    'Charts Module': 'Modul Berichte',
    'Goals Module': 'Modulvorgaben',
    'Manage Module': 'Modul verwalten',
    Group: 'Gruppe',
    Individual: 'Individuell',
    'Voiding Chart': 'Miktionsprotokoll',
    'Pad Fill Profile Chart': 'IKM-Füllprofil-Diagramm',
    'Body Position Chart': 'Körperpositionsdiagramm',
    'Smartz Devices Chart': 'Smartz®-Gerätediagramm',
    'Pad Fill Profile': 'IKM-Füllprofil',
    'Skin Care': 'IKM Tragedauer',
    Position: 'Position',
    Temperature: 'Temperatur',
    Admin: 'Admin',
    'My Account': 'Mein Konto',
    Role: 'Rolle',
    Organisation: 'Organisation',
    'Data Privacy': 'Datenschutz',
    View: 'Anzeigen',
    Share: 'Teilen',
    Print: 'Drucken',
    Save: 'Speichern',
    'Reset Password': 'Passwort zurücksetzen',
    Delete: 'Löschen',
    Add: 'Hinzufügen',
    Edit: 'Bearbeiten',
    Fall: 'Sturz',
    //end translate permissions list
    check_fall: 'STURZ ÜBERPRÜFEN',
    position_goal_not_allow_off:
      'Positionsvorgabe kann nicht AUSGESCHALTET werden, wenn Sturzvorgabe EINGESCHALTET ist, um die Sicherheit zu verbessern.',
    falls: 'Sturzerkennung',
    falls_detection_and_notification: 'Sturzerkennung und Benachrichtigung',
    falls_detection: 'Sturzerkennung',
    detect_falls: 'Sturzerkennung erkennen',
    on: 'EIN',
    position_goal: 'Positionsvorgabe',
    has_been_turn_on:
      'wurde EINGESCHALTET, um die Sturzerkennung zu ergänzen und die Sicherheit zu verbessern.',
    last_fall: 'Letzter Sturz',
    last_week: 'Letzte Woche',
    three_months: '3 Monate',
    time_to_change: 'Zeit zum Wechseln',
    sent_successfully: 'Erfolgreich gesendet',
    sent_failed: 'Senden fehlgeschlagen',
    send_email: 'E-Mail senden',
    send: 'Senden',
    add_email: 'E-Mail-Adresse hinzufügen',
    saved_successfully: 'Erfolgreich gespeichert',
    saved_failed: 'Speichern fehlgeschlagen',
    deleted_successfully: 'Erfolgreich gelöscht',
    deleted_failed: 'Löschen fehlgeschlagen',
    email: 'E-Mail-Adresse',
    please_enter_email_address: 'Bitte E-Mail-Adresse eingeben',
    please_enter_the_correct_email_address:
      'Bitte geben Sie die korrekte E-Mail-Adresse ein',
    time_in_a_pad_goal: 'VORGABE DER ZEIT IN EINEM IKM',
    time_goal: 'ZEITVORGABE',
    body_temperature: 'Körpertemperatur',
    upper_goal_limit: 'Obergrenze der Vorgabe',
    lower_goal_limit: 'Untergrenze der Vorgabe',
    time_of_fall: 'Zeitpunkt des Sturzes',
    heart_rate: 'Herzfrequenz',
    max_heart_rate: 'Max. Herzfrequenz',
    min_heart_rate: 'Min. Herzfrequenz',
    average_heart_rate: 'Durchschnittliche Herzfrequenz',
    oximetry: 'Oximetrie',
    blood_o2_saturation: 'O2-Sättigung des Blutes',
    min_oximetry: 'Min. Oximetrie',
    max_oximetry: 'Max. Oximetrie',
    average_oximetry: 'Durchschnittliche Oximetrie',
    respiration: 'Atmung',
    breathing_pattern: 'Atemmuster',
    breath: 'Atem',
    respiration_vs_oximetry: 'Atmung vs. Oximetrie',
    min_respiration: 'Min. Atmung',
    max_respiration: 'Max. Atmung',
    average_respiration: 'Durchschnittliche Atmung',
    balance: 'Gleichgewicht',
    falls_and_balance: 'Sturzerkennung und Gleichgewicht',
    loss_of_balance_events: 'Gesamtübersicht des Verlusts des Gleichgewichts',
    sudden_changes_in_body_orientation:
      'Plötzliche Veränderungen in der Körperorientierung',
    goal_limit: 'Grenze der Vorgabe',
    last_event_exceeding_goal:
      'Letztes Ereignis, das die Vorgabe überschreitet',
    balance_loss_events: 'Gesamtübersicht des Verlusts des Gleichgewichts',
    per_7_days: 'Pro 7 Tage',
    body_lean_over_7_days: 'Neigung des Körpers über 7 Tage',
    chart_shows_tendency:
      'Diagramm zeigt die Tendenz des Körpers, sich während der Bewegung in eine bestimmte Richtung zu neigen',
    lean_forward: 'Vorwärts lehnen',
    backwards: 'rückwärts',
    forward: 'vorwärts',
    vitals: 'VITALDATEN',
    vitals_signs: 'VITALPARAMETER',
    spo2: 'SPO2',
    pulse: 'Puls',
    abdominal_movement: 'Abdominale Bewegung',
    min: 'min.',
    attach_the_pod:
      'Bringen Sie den Pod erst an, wenn das {pad} bereits am {patient} angebracht ist. Die Nichtbeachtung dieser Anweisung könnte dazu führen, dass aufgrund der Bewegung und Handhabung des IKM fälschlicherweise ein Sturz registriert wird, bevor es am {patient} angebracht wird.',
    body_positions_analysis: 'Analyse der Körperposition',
    repositioning: 'Neupositionierung',
    stayed_in_one_position: 'in einer Position verblieben',
    change_in_position: 'Positionsänderung',
    no_pod_data: 'keine Pod-Daten',
    possible_intervention: 'Möglicher Eingriff',
    body_position_goal: 'VORGABE FÜR DIE KÖRPERPOSITON',
    tap_to_setup_body_position_goals:
      'Antippen, um Zielvorgaben für die Körperposition festzulegen',
    time_blocks_greater_than: 'Zeitblöcke größer als',
    will_be_highlighted: 'werden hervorgehoben',
    chart_filters: 'DIAGRAMMFILTER',
    tap_to_show: 'zum Anzeigen antippen',
    tap_to_hide: 'zum Ausblenden antippen',
    notifications: 'Benachrichtigungen',
    time_to_reposition: 'Zeit bis zur Neupositionierung',
    hour: 'Stunde',
    hours: 'Stunden',
    minute: 'Minute',
    minutes: 'Minuten',
    sensor_disconnected: 'Sensor Getrennt',
    from: 'VON',
    to: 'AN',
    quick_start_guide: 'Schnellstartanleitung',
    wet_outside: 'Nässe außerhalb des IKM',
    attend_fall: 'STURZ BEHANDELN',
    reclip_pod: 'POD ERNEUT ANBRINGEN',
    change_position: 'POSITION ÄNDERN',
    replace_battery: 'BATTERIE AUSTAUSCHEN',
    allowed_time_exceeded: 'Zulässige Zeit überschritten',
    wetness_outside: 'Nässe außerhalb',
    analysing_pad: '{pad} wird analysiert',
    pad_not_selected: '{pad} nicht ausgewählt',
    silence: 'Stummschalten',
    silence_confirm_box_title: 'Sturzerkennung stummschalten',
    silence_confirm_box_content:
      'Wenn Sie die Sturzbenachrichtigung stummschalten, wird sie aus dem Gruppen-Dashboard entfernt. Möchten Sie fortfahren? ',
    yes: 'JA',
    no: 'NEIN',
    pad_status: 'IKM-STATUS',
    check_pad_fill: 'IKMFÜLLUNG ÜBERPRÜFEN',
    patient_profile: '{patient} PROFIL',
    periods: 'Zeiträume',
    products: 'Produkte',
    active: 'aktiv',
    manage_user_profile: 'Benutzerprofil verwalten',
    sign_out: 'Abmelden',
    view: 'Anzeigen',
    groups: 'Gruppen',
    groups_in_view: 'Gruppen in der Anzeige',
    total_daily_profile: 'Gesamttagesprofil',
    day_profile: 'Profil für tagsüber',
    night_profile: 'Profil für nachts',
    pad_fill_profile_goal: 'VORGABE FÜR DAS {pad}-FÜLLPROFIL',
    tap_to_setup_pad_fill_profile_goals:
      'Antippen, um die Zielvorgaben für das {pad}-Füllprofil festzulegen',
    insufficient_data: 'Unzureichende Daten',
    last_7_days: 'Letzte 7 Tage',
    pad_removed: 'IKM entfernt',
    view_groups: 'Gruppe(n) anzeigen',
    minimum_voiding_into_pad: 'Minimale Entleerung in das {pad}',
    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',
    disconnected_desc:
      'Es wird darauf gewartet, dass der Pod erneut am {pad} angebracht wird ...',
    pod_unclipped_desc:
      'Es wird darauf gewartet, dass der Pod wieder in Reichweite kommt ...',
    password_policy: 'Richtlinie zu Passwörtern',
    position_chart: 'Positionsdiagramm',
    hi_everyone: 'Hallo allerseits!',
    voiding_chart_email_content:
      'Das per E-Mail versandte Miktionsprotokoll kann von Ihnen überprüft werden.',
    pad_fill_profile_chart_email_content:
      'Das per E-Mail versandte {pad}-Füllprofil-Diagramm kann von Ihnen überprüft werden.',
    position_chart_email_content:
      'Das per E-Mail versandte Positionsdiagramm kann von Ihnen überprüft werden.',
    temperature_chart_email_content:
      'Das per E-Mail versandte Temperaturdiagramm kann von Ihnen überprüft werden.',
    heare_rate_chart_email_content:
      'Das per E-Mail versandte Herzfrequenzdiagramm kann von Ihnen überprüft werden.',
    oximtry_chart_email_content:
      'Das per E-Mail versandte Oximetrie-Diagramm kann von Ihnen überprüft werden.',
    respiration_chart_email_content:
      'Das per E-Mail versandte Atmungsdiagramm kann von Ihnen überprüft werden.',
    balance_chart_email_content:
      'Das per E-Mail versandte Gleichgewichtsdiagramm kann von Ihnen überprüft werden.',
    smartz_chart_email_content:
      'Das per E-Mail versandte Smartz®-Diagramm kann von Ihnen überprüft werden.',
    best_regards: 'Mit freundlichen Grüßen',
    the_simavita_team: 'Das Smartz Operations Team',
    days: 'Tage',
    weeks: 'Wochen',
    years: 'Jahre',
    reset_all_users_passwords: 'Alle Benutzer-Passwörter zurücksetzen',
    reset_all_passwords: 'Alle Passwörter zurücksetzen',
    reset: 'Zurücksetzen',
    change_password: 'Passwort ändern',
    old_password: 'Altes Passwort',
    lowercase: 'Kleinbuchstabe',
    uppdercase: 'Großbuchstabe',
    number: 'Zahl',
    please_select: 'Bitte auswählen',
    loading_chart: 'Diagramm wird geladen',
    please_wait: 'Einen Augenblick bitte ...',
    edit_user: 'Benutzer bearbeiten',
    add_user: 'Benutzer hinzufügen',
    edit_group: 'Gruppe bearbeiten',
    add_group: 'Gruppe hinzufügen',
    group_name: 'Gruppenname',
    group_name_required: 'Gruppenname ist erforderlich',
    patients: '{patients}',
    manage_user_account: 'Benutzerkonto verwalten',
    filter_by_group_name: 'Nach Gruppenname filtern',
    delete_group_warning:
      'Bitte beachten Sie, dass das Löschen einer Gruppe endgültig ist.',
    delete_patient_warning:
      'Das Löschen von {patient} und personenbezogenen Daten ist endgültig.',
    pod_mac: 'Pod Mac',
    pod_serial_number: 'Pod-Seriennummer',
    add_patient: '{patient} hinzufügen',
    edit_patient: '{patient} bearbeiten',
    alias: 'Pseudonym',
    alias_required: 'Pseudonym ist erforderlich',
    pod_mac_required: 'Pod Mac ist erforderlich',
    pod_serial_number_required: 'Seriennummer ist erforderlich',
    please_enter_capital_letters_and_numbers:
      'Bitte geben Sie Großbuchstaben und Zahlen ein',
    select_date_range: 'Datumsbereich auswählen',
    start_time: 'Startzeit',
    end_time: 'Endzeit',
    select_groups_to_collate:
      'Wählen Sie die Gruppe(n) aus, die zusammengestellt werden soll(en)',
    all_groups: 'Alle Gruppen',
    export_report: 'Bericht exportieren',
    export_csv: 'CSV exportieren',
    reports: 'Berichte',
    please_complete_form: 'Bitte füllen Sie das Formular aus',
    nodes: 'Knoten',
    network_map: 'Netzwerkkarte',
    network_utilisation: 'Netzwerkauslastung',
    notify_me_when_nodes_offline:
      'Mich benachrichtigen, wenn (ein) Knoten offline ist/sind',
    zoom_in_chart: 'Zoom im Diagramm aktivieren',
    latency: 'Latenz',
    lan: 'LAN',
    wifi_infrastructure: 'WLAN-Infrastruktur',
    standard_iot_network_map: 'Standard IoT Netzwerkkarte',
    pods: 'Pods',
    data: 'Daten',
    packet_less: 'Datenpaket geringer',
    secondary_connection: 'Sekundäre Verbindung',
    rssi: 'RSSI',
    no_nodes: 'Keine Knoten',
    share_code: 'Code teilen',
    //Start translation from here.
    active_patients: 'Aktive {patients}',
    archived_patients: 'Archivierte {patients}',
    archive: 'archivieren',
    restore: 'wiederherstellen',
    are_you_sure: 'Sind Sie sicher?',
    you_about_to_archive: `Sie sind dabei, zu archivieren`,
    default_group_not_delete: 'Die Standardgruppe kann nicht gelöscht werden',
    patients_belong_to: 'Patienten, zugehörig zu',
    move: 'Verschieben',
    warning: 'Warnung',
    add_node: 'Knoten hinzufügen',
    edit_node: 'Knoten bearbeiten',
    room_name: 'Name des Zimmers',
    mac_address: 'MAC-Adresse',
    delete_node_warning: 'Das Löschen des Knotens ist endgültig. ',
    mac_address_required: 'MAC-Adresse ist erforderlich',
    room_name_required: 'Name des Zimmers ist erforderlich',
    mac_address_format_warning:
      'Das eingegebene MAC-Adressformat ist falsch. Bitte in Form von XX: XX:XX:XX:XX:XX eingeben',
    connection_type: 'Verbindungstyp',
    device_role: 'Geräterrolle',
    device_type: 'Gerätetyp',
    offline: 'Offline',
    node_management: 'Knotenverwaltung',
    time_period: 'Zeitraum',
    manufacturer: 'Hersteller',
    product: 'Produkt',
    please_select_time_period: 'Bitte wählen Sie den Zeitraum aus',
    please_select_manufacturer: 'Bitte wählen Sie den Hersteller aus',
    please_select_product: 'Bitte wählen Sie das Produkt aus',
    no_data: 'Keine Daten vorhanden',
    please_select_manufacturer_first:
      'Bitte wählen Sie zuerst den Hersteller aus',
    details: 'Details',
    time_period_warning:
      'Die Tageszeit und die Nachtzeit müssen die gesamten 24 Stunden des Tages abdecken.',
    reset_successfully: 'Zurücksetzen erfolgreich',
    region: 'Region',
    select_at_least_one_group: 'Wählen Sie mindestens eine Gruppe aus',
    node: 'Knoten',
    pods_location: 'Pods-Standort',
    pod_id: 'Pod-ID',
    accelerometer: 'Beschleunigungsmesser',
    senser: 'Sensor',
    gain: 'Zunahme',
    offset: 'Verschiebung',
    failed_to_connecte_smartz_service:
      'Verbindung zum Smartz<sup>®</sup>-Dienst fehlgeschlagen',
    add_to_smartz_group_failed:
      'Hinzufügen zum Smartz-Gruppendienst fehlgeschlagen',
    retry: 'Nochmals versuchen',
    customization: 'Anpassung',
    customization_settings: 'Anpassungseinstellungen',
    colors: 'Farben',
    font: 'Schriftart',
    logo: 'Logo',
    login_background: 'Login-Hintergrund',
    apply: 'Für die',
    theme: 'aktuelle Website',
    to_current_site: 'anwenden',
    customize_theme_text:
      'Passen Sie das Aussehen der Website an Sind Sie auf Abenteuer aus?',
    create_a_custom_theme: 'Erstellen Sie ein benutzerdefiniertes Thema',
    custom_theme: 'Benutzerdefiniertes Thema',
    preview: 'Vorschau',
    reset_customization_settings:
      'Alle Konfigurationen wurden auf den Standardwert zurückgesetzt',
    drag_the_logo_here: 'Ziehen Sie das Logo hierher',
    or: 'oder',
    click_upload: 'klicken Sie auf Hochladen',
    only_image_files_can_be_uploaded:
      'Es können nur JPG/PNG-Dateien hochgeladen werden',
    the_size_of_the_uploaded_image_cannot_exceed:
      'Die Größe des hochgeladenen Bildes darf 2 MB nicht überschreiten',
    please_sign_out_to_preveiw_effect:
      'Melden Sie sich nach dem Hochladen ab, um die Wirkung in der Vorschau anzuzeigen',
    please_enter_theme_name: 'Bitte geben Sie den Namen des Themas ein',
    failed: 'Fehlgeschlagen',
    add_pod: 'Pod hinzufügen',
    edit_pod: 'Pod bearbeiten',
    filter_pod: 'Nach Pod-MAC-Adresse filtern',
    filter_node: 'Nach Knoten, MAC-Adresse und Zimmer filtern',
    delete_pod_warning: 'Das Löschen des Pod ist endgültig. ',
    delete_theme_warning: 'Das Löschen des Themas ist endgültig.',
    apply_theme_warning:
      'Hinweis: Dieser Vorgang wendet die benutzerdefinierten Einstellungen auf den Domainnamen an. Seien Sie bitte vorsichtig.',
    please_enter_domain_name: 'Bitte geben Sie den Domainnamen ein',
    domain_name_incorrect: 'Das Format des Domainnamens ist falsch',
    apply_successfully: 'Erfolgreich angewendet',
    location: 'Standort',
    manufacturer_code: 'Herstellercode',
    node_mac_address: 'MAC-Adresse des Knotens',
    expired: 'Abgelaufen',
    please_select_location: 'Bitte Standort auswählen',
    filter_patients: '{patients} filtern',
    monitor_patient: '{patient} überwachen',
    patient: '{patient}',
    room: 'Zimmer',
    assign: 'Zuweisen',
    unassign: 'Zuweisung aufheben',
    unassign_patient_permanent:
      'Bitte beachten Sie, dass das Aufheben der Zuweisung des Patienten endgültig ist.',
    you_able_to_unassign: `Sie sind dabei, die Zuweisung aufzuheben`,
    node_mac_address_required: 'MAC-Adresse des Knotens ist erforderlich',
    not_assigned: 'Nicht zugewiesen',
    assign_node_to: 'Knoten zuweisen zu',
    create_user: 'Benutzer erstellen',
    email_is_required: 'E-Mail-Adresse ist erforderlich',
    created_successfully: 'Erfolgreich erstellt',
    manage_patient_data: '{patient} VERWALTEN',
    selected_patient: 'AUSGEWÄHLTER {patient}',
    archive_patient: '{patient} ARCHIVIEREN',
    archive_patient_warning:
      '{patient} archivieren. Der {patient} erscheint nicht mehr im System, bis er wiederhergestellt ist.',
    archive_patient_data: '{patient} archivieren',
    restore_patient: '{patient} wiederherstellen',
    restore_patient_warning:
      'Archivierte Daten wiederherstellen, damit sie in diesem System angezeigt werden können.',
    archive_date: 'Archivierungsdatum',
    restore_patient_data: '{patient} wiederherstellen',
    delete_account: 'KONTO LÖSCHEN',
    user_accounts: 'Benutzerkonten',
    selected_site: 'Ausgewählte Website',
    no_site: 'Keine Website',
    drag_the_login_background_here: 'Ziehen Sie den Login-Hintergrund hierher',
    drag_the_menu_background_here: 'Ziehen Sie den Menü-Hintergrund hierher',
    patient_data_privacy: 'DATENSCHUTZ BEI PATIENTEN',
    edit_theme: 'Thema bearbeiten',
    drag_the_main_content_background_here:
      'Ziehen Sie den Hintergrund des Hauptinhalts hierher',
    opacity_desc:
      'Opazität (Transparenz von im Hintergrund gesperrten Inhalten)',
    menu_bg: 'Menü-Hintergrund',
    main_content_bg: 'Hintergrund des Hauptinhalts',
    background: 'Hintergrund',
    account: 'Konto',
    super_admin: 'Super-Admin',
    help: 'Hilfe',
    filter_by_user_name: 'nach Benutzernamen filtern',
    drag_the_top_nav_background_here:
      'Ziehen Sie den Hintergrund des oberen Navigationsbereichs hierher',
    apply_theme: 'Thema anwenden',
    apply_to_this_domain: 'Auf diese Domain anwenden',
    crop_image: 'Bild zuschneiden',
    enlarge: 'Vergrößern',
    narrow: 'Schmälern',
    left_rotation: 'Linksdrehung',
    right_rotation: 'Rechtsdrehung',
    remove_image: 'Bild entfernen',
    operation_area: 'Betriebsbereich',
    preview_area: 'Vorschaubereich',
    logo_shape: 'Logo-Form',
    show_as_circle: 'Als kreisförmiges Symbol anzeigen',
    history: 'Verlauf',
    status: 'Status',
    download: 'Herunterladen',
    export: 'Exportieren',
    created_date: 'Erstellungsdatum',
    next: 'Weiter',
    register: 'Registrieren',
    back: 'Zurück',
    create_an_organisation: 'Eine Organisation erstellen',
    please_enter_organisation_name:
      'Bitte geben Sie den Namen der Organisation ein',
    address: 'Adresse',
    please_enter_organisation_address:
      'Bitte geben Sie die Adresse der Organisation ein',
    phone: 'Telefon',
    please_enter_organisation_phone:
      'Bitte geben Sie die Telefonnummer der Organisation ein',
    description: 'Beschreibung',
    add_facility: 'Einrichtung hinzufügen',
    edit_facility: 'Einrichtung bearbeiten',
    facility: 'Einrichtung',
    no_room: 'Kein Zimmer',
    facility_name: 'Name der Einrichtung',
    add_room: 'Zimmer hinzufügen',
    room_already_exists: 'Zimmer bereits vorhanden',
    home: 'Home',
    signed_into: 'Angemeldet bei',
    please_select_an_organisation: 'Bitte wählen Sie eine Organisation aus',
    hello: 'Hallo',
    useful_features: 'Nützliche Funktionen',
    attention: 'Aufmerksamkeit',
    quick_actions: 'Schnellzugriff',
    no_patient_warning:
      'Es gibt keine zu überwachenden {patients}. Fügen Sie jetzt {patients} hinzu, um loszulegen.',
    add_patient_quick_action_desc:
      'Fügen Sie einen zu überwachenden {patient} hinzu',
    welcome_to_the_group_dashboard: 'Willkommen im Gruppen-Dashboard',
    show_me_more: 'Mehr anzeigen',
    add: 'hinzufügen',
    welcome_to_patient_management: 'Willkommen im {patient} management',
    update_patient: '{patient} aktualisieren',
    update_patient_quick_action_desc: `{patient} aktualisieren`,
    change_patient_products: `Produkte des {patient} ändern`,
    change_patient_products_quick_action_desc:
      'Vom {patient} verwendetes Produkt ändern',
    reassign_pod_to_patient: 'Pod dem {patient} neu zuweisen',
    reassign_pod_quick_action_desc: `Pod des {patient} auswechseln`,
    monitor_patient_with_a_node: 'Knoten dem {patient} zuweisen',
    monitor_patient_with_a_node_quick_action_desc:
      'Knoten eines {patient} überprüfen',
    welcome_to_the_administration_section:
      'Willkommen im Administrationsbereich',
    invite_user: 'Benutzer einladen',
    invite_user_quick_action_desc: 'Einen Benutzer zum System einladen',
    remove_or_archive_patient: '{patient} entfernen/archivieren',
    remove_or_archive_patient_quick_action_desc:
      'Einen {patient} aus dem Dashboard entfernen',
    profile: 'Profil',
    not_monitored: 'nicht überwacht',
    rounds: 'Runden',
    //translate permissions list
    'Super Admin': 'Super-Admin',
    Algorithms: 'Algorithmen',
    Customisation: 'Anpassung',
    Account: 'Konto',
    'Roles & Permissions': 'Rollen und Berechtigungen',
    'Network Map': 'Netzwerkkarte',
    'Network Utilisation': 'Netzwerkauslastung',
    'Buildings & Rooms': 'Einrichtungen und Zimmer',
    Manufacturers: 'Hersteller',
    Settings: 'Einstellungen',
    Profile: 'Profil',
    Devices: 'Geräte',
    Nodes: 'Knoten',
    'Pods Location': 'Pods-Standort',
    'Share Code': 'Code teilen',
    Users: 'Benutzer',
    'User Accounts': 'Benutzerkonten',
    'Invite User': 'Benutzer einladen',
    Patients: 'Patienten',
    'Monitor Patient': 'Patient überwachen',
    'Patient Data Privacy': 'Datenschutz für Patienten',
    Archive: 'Archivieren',
    Restore: 'Wiederherstellen',
    'Patients Module': 'Patienten-Modul',
    Export: 'Exportieren',
    History: 'Verlauf',
    Report: 'Bericht',
    Monitor: 'Überwachen',
    //translate permissions list
    time_zone: 'Zeitzone',
    please_select_time_zone: 'Bitte wählen Sie eine Zeitzone aus',
    add_facility_and_room: 'EINRICHTUNG UND ZIMMER HINZUFÜGEN',
    filter_by_facility_name: 'nach Name der Einrichtung filtern',
    floor: 'Etage',
    please_enter_facility_name: 'Bitte geben Sie den Namen der Einrichtung ein',
    please_enter_floor_name: 'Bitte geben Sie den Namen der Etage ein',
    please_enter_room_number: 'Bitte geben Sie die Zimmernummer ein',
    facility_name_already_exists:
      'Der Name der Einrichtung ist bereits vorhanden',
    floor_name_should_be_unique: 'Der Name der Etage sollte eindeutig sein',
    room_number_should_be_unique: 'Die Zimmernummer sollte eindeutig sein',
    add_manufacturer: 'Hersteller hinzufügen',
    filter_by_manufacturer_code_or_name:
      'nach Herstellercode oder -name filtern',
    enabled: 'Aktiviert',
    delete_manufacturer_warning: 'Das Löschen des Herstellers ist endgültig. ',
    please_enter_role_name: 'Bitte geben Sie die Bezeichnung der Rolle ein',
    please_choose_one_as_the_current_organization:
      'Bitte wählen Sie eine als aktuelle Organisation aus',
    display_name: 'Anzeigename',
    assign_roles: 'Rollen zuweisen',
    remove: 'Entfernen',
    please_assign_a_role_to_the_user:
      'Bitte weisen Sie dem Benutzer eine Rolle zu',
    send_invitation: 'Einladung senden',
    invitation_email_sent: 'Einladung per E-Mail gesendet.',
    facility_and_Floor_and_Room: 'Einrichtung, Etage und Zimmer',
    export_patient: '{patient} exportieren',
    export_patient_history_data: 'Verlaufsdaten des {patient} exportieren',
    export_patient_data: '{patient} exportieren',
    export_report_success_text: `Export der {patient} läuft. Sie werden per E-Mail benachrichtigt, sobald sie verfügbar sind. Überprüfen Sie den Fortschritt auf der Registerkarte „Dateien”. `,
    select_patients: '{patients} auswählen',
    export_in_progress: 'Export läuft',
    continue: 'fortfahren',
    please_enter_patient_name: `Bitte geben Sie den Namen des {patient} ein`,
    please_enter_patient_alias: `Bitte geben Sie das Pseudonym des {patient} ein`,
    facility_and_room: 'Einrichtung und Zimmer',
    create_new: 'Neu erstellen',
    add_facility_and_floor_and_room: 'Einrichtung, Etage und Zimmer hinzufügen',
    select_facility_floor_room: 'Einrichtung, Etage und Zimmer auswählen',
    choose_one: 'Eines auswählen',
    enter_manually: 'Manuell eingeben',
    pod_serial_number_format_incorrect:
      'Das eingegebene Format der Pod-Seriennummer ist falsch.',
    add_a_manufacturer_to_continue:
      'Fügen Sie einen Hersteller hinzu, um fortzufahren',
    please_enter_subscription_code: 'Bitte geben Sie einen Abonnement-Code ein',
    added_successfully: 'Erfolgreich hinzugefügt',
    select_a_patient: 'Wählen Sie einen {patient} aus',
    assign_products: 'Produkte zuweisen',
    assign_pod: 'Pod zuweisen',
    assign_node: 'Knoten zuweisen',
    we_have_created_a_default_facility:
      'Wir haben eine Standardeinrichtung, eine Standardetage und ein Standardzimmer für Ihre Organisation geschaffen',
    if_you_want_edit_this_facility: `Wenn Sie die Informationen dieser Einrichtung bearbeiten möchten, tippen Sie auf`,
    or_you_can: 'Oder Sie können',
    already_registered: 'Bereits registriert',
    sign_up: 'Registrieren',
    create_account: 'Konto erstellen',
    pod_and_diaper: 'Pod und {pad}',
    pod_and_diaper_content: ` <p class="underline">Befolgen Sie diese Schritte, um den Pod mit der {pad} zu verbinden:</p>
          <ul>
            <li>
Linieren Sie die drei Streifen der Smart-{pad} mit den drei Goldnadeln des Smart-Pods
            </li>
            <li>Bringen Sie den Pod an der <span class="underline">Vorderseite</span> der Smart-{pad} an</li>
            <li>
Grünes Licht blinkt schnell für 3 Sekunden, dann dauerhaft für 1 Sekunde = gute Verbindung
            </li>
            <li>
Kein grünes Blinklicht nach 20 Sekunden = keine Verbindung. Trennen Sie den Smart-Pod ab und bringen Sie ihn erneut an
            </li>
            <li>Wenn bei ordnungsgemäßer Verbindung kein Licht blinkt, ist die Batterie leer</li>
          </ul>`,
    home_landing_slide1_title: 'Willkommen im Gesundheitsportal',
    home_landing_slide1_content: `
      <p>Mit dem Gesundheitsportal können Sie die Kontinenz und das Wohlbefinden Ihres {patient} überwachen.</p>
      <p>Überwachen Sie {patients}, um Maßnahmen zu priorisieren und eine individuelle zentrierte Versorgung zu gewährleisten.</p>`,
    home_landing_slide2_title: 'Smart-{pad}-Technologie',
    home_landing_slide2_content: `
      <p>Wenn ein Smart-Pod an eine Smart-{pad} angeschlossen ist, überträgt er Daten über ein Netzwerk, wodurch der Betreuer den {patient} über das Gesundheitsportal überwachen kann.</p>
      <p>Sobald Ihr {patient} im System zugewiesen ist, wissen Sie auf einen Blick, wann Sie die {pad} wechseln müssen, und können sich Verlaufsdaten anzeigen lassen. Sie können auch ganz einfach Zielvorgaben setzen und benachrichtigt werden, wann Sie die {pad} wechseln, die Position Ihres {patient} ändern, die Flüssigkeitsausscheidung überwachen, die Umgebungstemperatur messen und mögliche Sturzerkennung überprüfen müssen.</p>`,
    home_landing_slide4_title: 'Fügen Sie den ersten {patient} hinzu',
    home_landing_slide4_content: `
      <p>Fügen Sie zunächst einen {patient} hinzu, indem Sie die Schaltfläche „Schnellzugriff” verwenden und den Anweisungen folgen.</p>
      <p>Das System unterstützt Sie während des gesamten Vorgangs der Einstellung des {patient}.</p>`,
    home_landing_slide5_title: 'Schnellzugriff',
    home_landing_slide5_content: `
      <p>Damit können Sie auf häufige Maßnahmen wie das Hinzufügen eines {patient} zugreifen.</p>
      <p>Ein Assistent führt Sie durch alle notwendigen Schritte. </p>`,
    dashboard_landing_slide1_title: 'Willkommen im Gruppen-Dashboard',
    dashboard_landing_slide1_content: `
      <p>Überwachen Sie alle Ihre {patients} im Dashboard und erkennen Sie, wann Ihre {patients} Aufmerksamkeit benötigen.</p>
      <p>Ihre Arbeitsbelastung kann reduziert werden, indem Sie den visuellen Aufforderungen des Systems folgen.</p>`,
    dashboard_landing_slide2_title: 'Willkommen im Gruppen-Dashboard',
    dashboard_landing_slide2_content: `<ul>
      <li>Es werden Symbole angezeigt, die den Status des {patient} ausweisen</li>
      <li>Es gibt zwei Bereiche auf dem Dashboard, den Bereich <span class="underline">Maßnahme erforderlich</span> und den Bereich <span class="underline">Monitoring</span></li>
      <li>Um die Arbeitsbelastung zu reduzieren und die {patient} zu verbessern, konzentrieren Sie sich auf die Symbole <span class="underline">„Maßnahme erforderlich”</span> mit hoher Priorität</li>
    </ul>`,
    dashboard_landing_slide3_title: 'Der {pad} status',
    dashboard_landing_slide3_content: `
      <p>Der Der {pad} status und „Zeit zum Wechseln” wird mittels eines Ampelsystems dargestellt:</p>
      <ul>
        <li><span class="red-text"><span class="underline">Rot</span> = {pad} wechseln,</span> d. h. nasse {pad}, die auslaufen kann</li>
        <li><span class="yellow-text"><span class="underline">Gelb</span> = Wechsel der {pad} vorbereiten,</span> d. h. {pad} erreicht Kapazität</li>
        <li><span class="green-text"><span class="underline">Grün</span> = keine Maßnahme</span>, d. h. trockene {pad}</li>
      </ul>`,
    dashboard_landing_slide4_title: 'Andere Status',
    dashboard_landing_slide4_content: `
      <p>Um die Kontinuität der Pflege zu gewährleisten, beachten Sie alle auf dem Dashboard angezeigten Maßnahmen:</p>
      <ul>
        <li>Das Symbol „Verbindung verloren” zeigt an, dass die Bluetooth-Verbindung verloren gegangen ist und es zu Datenverlust kommen kann.</li>
        <li>Das Symbol „Position wechseln“ zeigt an, dass es an der Zeit ist, die Position des {patient} zu ändern.</li>
      </ul>`,
    dashboard_landing_slide5_title: 'Optimieren',
    dashboard_landing_slide5_content: `<p>Überprüfen Sie die Gruppen-Dashboard-Benachrichtigungen, um Ihre tägliche {patient} zu optimieren.</p>`,
    dashboard_landing_slide6_title: 'Bereichsfilter',
    dashboard_landing_slide6_content: `
      <p>Der Bereichsfilter ist eine optionale Funktion, mit der Sie einen ausgewählten Bereich der Einrichtung auf Ihrem Dashboard anzeigen können. Verwenden Sie die Bereichsfilter mit Vorsicht, da sie vorhandene {patients} ausblenden und nur die Filterauswahl anzeigen.</p>
      <p>So wählen Sie den neuen Bereichsfilter aus: </p>
      <ol>
        <li>Wählen Sie das Dropdown-Menü für Bereiche aus</li>
        <li>Tippen Sie auf „Neuer Bereich“</li>
        <li>Geben Sie den „Namen des Bereichsfilters” ein</li>
        <li>Wählen Sie das Gebäude aus</li>
        <li>Markieren Sie den Bereich, die Etage und die Zimmernummern</li>
        <li>Überprüfen Sie Ihre Filterauswahl im Feld „Zusammenfassung der Filter”</li>
        <li>Antippen, um diesen Bereichsfilter zu speichern</li>
        <li>Wählen Sie im Dropdown-Menü den Bereichsfilter oder die Option „Bereiche verwalten“ aus</li>
      </ol>
    `,
    home_landing_slide3_title: 'Pod und {pad}',
    home_landing_slide3_content: `
    <ul>
      <li>Pod an {pad} anschließen</li>
      <li>Beobachten Sie die grünen LED-Leuchten auf dem Pod</li>
      <li>Erhalten Sie Aktualisierungen des Status des {patient}</li>
    </ul>`,
    patient_landing_slide1_title: 'Individuelles Dashboard',
    patient_landing_slide1_content: `
      <p>Wenn Sie einen einzelnen {patient} auswählen, zeigt ein neues Dashboard den Status aller derzeit überwachten Funktionen an, einschließlich des verwendeten Smart-Pods und der verwendeten {pad}.</p>
      <p>Wählen Sie einen anderen {patient} aus, der im Dropdown-Menü angezeigt werden soll.</p>`,
    patient_landing_slide2_title: `Willkommen im {patient} bereich`,
    patient_landing_slide2_content: `
      <p>Das individuelle Dashboard zeigt den aktuellen Status des {patient} an.</p>
      <p>Der Bereich „Berichte” erfasst Gesundheitstrends.</p>
      <p>Bestimmte Zielvorgaben können im Bereich „Zielvorgaben” festgelegt werden, und Benachrichtigungen können erhalten werden.</p>`,
    patient_landing_slide3_title:
      'Zugriff auf individuelle Dashboards, Berichte und Zielvorgaben',
    patient_landing_slide3_content: `<p>Auf der linken Seite des Dashboards können Sie auf den Bereich {patient}, Berichte und Zielvorgaben” zugreifen.</p>`,
    patient_landing_slide4_title: '{patient}/Individuelles Dashboard',
    patient_landing_slide4_content: `
      <ul>
        <li>Jeder {patient} hat sein eigenes Dashboard</li>
        <li>Erforschen Sie den individuellen Status Ihres {patient}</li>
        <li>Wechseln Sie zwischen {patients}, indem Sie sie mit dem Dropdown-Pfeil auswählen</li>
      </ul>`,
    patient_landing_slide5_title: 'Berichte',
    patient_landing_slide5_content: `
      <p>Es gibt verschiedene Berichte, mit denen Sie Daten anzeigen und interpretieren können, darunter:</p>
      <ul>
        <li>Miktionsprotokoll</li>
        <li>{pad}-Füllprofil</li>
        <li>Positionsdiagramm.</li>
      </ul>
      <p>Sie können diese ausdrucken und weitergeben, um die Behandlung Ihres {patient} zu überprüfen und anzupassen.</p>`,
    patient_landing_slide6_title: 'Zielvorgaben',
    patient_landing_slide6_content: `
      <p>Um die Versorgung Ihres {patient} weiter zu verbessern, können spezifische Zielvorgaben festgelegt werden. Diese umfassen:</p>
      <ul>
        <li>Körperneupositionierung</li>
        <li>{pad} Tragedauer</li>
        <li>{pad}-Füllprofil</li>
        <li>Temperatur</li>
        <li>Sturzerkennung.</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>Wählen Sie den {patient} aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>Mit der Auswahl des Datumsbereichs können maximal 7 Tage angezeigt werden.</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>Das Miktionsprotokoll bietet eine ganzheitliche Ansicht des Entleerungsverlaufs Ihres {patients}.</li>
        <li>Bei der Verwendung des Smartz<sup>®</sup>-Systems werden Echtzeitdaten im Miktionsprotokoll angezeigt.</li>
        <li>In diesem Diagramm können Sie zwischen der Anzeige des {pad}-Zyklus oder der Übersicht über Entleerungsereignisse wechseln.</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>Symbole können durch Auswahl gefiltert werden.</li>
        <li>Die Legende unter dem Miktionsprotokoll zeigt die im Diagramm angezeigten Symbole.</li>
        <li>Tippen Sie auf „Diagrammfilter“, um die Symbole auszuwählen oder abzuwählen, die Sie anzeigen möchten.</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>Durch das Anzeigen dieses Diagramms können Sie:</p>
      <ul>
        <li>mögliche Zeiten identifizieren, in denen der {patient} erfolgreich auf die Toilette gehen kann</li>
        <li>ob die {pad} innerhalb eines akzeptablen Zeitraums gewechselt wurde</li>
        <li>die Anzahl der Padwechsel über den Zeitraum</li>
        <li>teilen und Ihr Diagramm ausdrucken.</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>Das Ereignisdiagramm zeigt alle Gesamtübersicht für den Status von {pad}, Pod, Zielvorgaben und Netzwerk an.</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>Das „Gesamttagesprofil” zeigt die Gesamtmenge der Flüssigkeit an, die über einen Zeitraum von 24 Stunden in das {pad} entleert wurde.</li>
        <li>Die tägliche Ausscheidung in die {pad} wird über jedem Tropfen angezeigt.</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>Das Symbol auf der rechten Seite zeigt das „durchschnittliche” Volumen der Ausscheidung über den ausgewählten Zeitraum von Tagen an.</li>
        <li>Aktivieren Sie diese Option, um die Profile „Tag“ und „Nacht“ getrennt anzuzeigen.</li>
        <li>Das Diagramm zeigt an, ob eine Vorgabe für das {pad}-Füllprofil festgelegt oder ausgelöst wurde.</li>
        <li>Wählen Sie bei Bedarf aus, die Vorgabe festzulegen.</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>Das Gesamttagesprofil zeigt die gesamte Flüssigkeitsmenge an, die während eines Zeitraums von 24 Stunden in die {pad} entleert wurde.</li>
        <li>Wenn sich die Ausscheidung von Urin beim {patient} verringert, kann dies ein Indikator sein, die Flüssigkeitszufuhr zu erhöhen.</li>
        <li>Teilen und drucken Sie Ihr Diagramm aus.</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>Das Diagramm zeigt die Zeitdauer in einer Körperposition über eine ausgewählte Anzahl von Tagen an.</li>
        <li>Bewegen Sie den Mauszeiger über das Diagramm, um weitere Details anzuzeigen.</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>Tippen Sie auf „Diagrammfilter“, um die Positionen auszuwählen oder abzuwählen, die Sie anzeigen lassen möchten.</li>
        <li>Das Diagramm hebt hervor, ob eine Vorgabe für die Körperposition festgelegt wurde.</li>
        <li>Antippen, um die Vorgabe festzulegen.</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>Wenn Sie einen {patient} haben, der für Hautschäden/Druckverletzungen anfällig ist, werden Sie durch Festlegen der Vorgabe darüber informiert, wann es Zeit ist, die Position des {patient} zu ändern.</li>
        <li>Bei Auswahl von „Drucken” werden die Positionen und die Zeiträume mit zusätzlichen Details aufgelistet. </li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>Gehen Sie zum Bereich „Glühbirnen” für weitere Details.</li>
      </ul>`,
    body_position_goal_help_title: 'Ziel der Körperneupositionierung',
    body_position_goal_slide1_content: `
      <ul>
        <li>Durch Festlegen der Vorgabe wird der Betreuer darüber informiert, wann es Zeit ist, die Position des Patienten zu ändern.</li>
        <li>Verwenden Sie diese Vorgabe, wenn Sie einen Patienten haben, der für Hautschäden/Druckverletzungen anfällig ist.</li>
        <li>Die Reduzierung der Zeit in einer Position könnte helfen, Druckverletzungen zu lindern.</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den {patient} aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler, um die maximale Zeitdauer auszuwählen, während der sich Ihr {patient} tagsüber bzw. nachts in einer bestimmten Position befinden soll.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>Sie haben nun die maximale Zeitdauer ausgewählt, während der sich Ihr {patient} in einer bestimmten Position befinden soll, und Sie werden im Bereich „Maßnahme erforderlich” benachrichtigt, wann Sie sie ändern müssen.</li>
      </ul>`,
    skin_management_goal_help_title: 'Vorgabe für das Hautmanagement',
    skin_management_goal_slide1_content: `
      <ul>
        <li>Ein regelmäßigerer Wechsel der {pad} kann dazu beitragen, die Haut des {patient} trocken zu halten und Hautirritationen zu reduzieren.</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den {patient} aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler, um die maximale Zeitdauer auszuwählen, während der Ihr {patient} eine {pad} tragen soll.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>Sie werden nun im Abschnitt „Maßnahme erforderlich” benachrichtigt, wenn Sie die {pad} des {patient} wechseln müssen.</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Umgebungstemperatur des Pods',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>Mit dieser Vorgabe können Sie die minimale/maximale Umgebungstemperatur des Pods einstellen.</li>
        <li>Legen Sie sich diese Vorgabe fest, wenn Sie Bedenken bezüglich der Temperaturschwankung Ihres {patient} haben.</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den {patient} aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Um über eine Temperaturänderung in der Umgebung des Pods benachrichtigt zu werden, bewegen Sie den Schieberegler, um die minimalen und maximalen Temperaturen auszuwählen.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>Sie werden nun im Abschnitt „Maßnahme erforderlich” benachrichtigt, wenn die Umgebungstemperatur des Pod außerhalb des eingestellten Bereichs liegt.</li>
      </ul>`,
    pad_fill_profile_goal_help_title: 'Vorgabe für das {pad}-Füllprofil',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>Mit dieser Vorgabe können Sie das minimale/maximale Entleerungsvolumen in die {pad} einstellen, wenn Sie befürchten, dass Ihr {patient} eine geringe Urinausscheidung hat.</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den {patient} aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler, um das bevorzugte Volumen für den Tag bzw. für die Nacht auszuwählen.</li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>Sie werden nun im Bereich „Maßnahme erforderlich” benachrichtigt, wenn das Ausscheidungsvolumen Ihres {patient} in die {pad} außerhalb des eingestellten Bereichs liegt.</li>
      </ul>`,
    fall_detection_goal_help_title: 'Vorgabe für die Sturzerkennung',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>Diese Vorgabe benachrichtigt Sie, wenn Ihr {patient} gestürzt ist.</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>Wählen Sie den {patient} aus, der angezeigt werden soll, indem Sie einfach das Dropdown-Menü verwenden.</li>
        <li>Bewegen Sie den Schieberegler in die Position EIN, um die Vorgabe zu aktivieren.</li>
        <li>Standardmäßig ist die „Zeit in Position” eingeschaltet. </li>
        <li>Antippen, um die Vorgabe zu speichern.</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>Wenn ein Sturz aufgetreten ist, wird ein blinkendes Symbol im Abschnitt „Maßnahme erforderlich” angezeigt.</li>
        <li>Wenn Sie den Sturz in „Individuelles Dashboard” stummschalten, wird das Symbol aus dem Haupt-Dashboard entfernt.</li>
      </ul>`,
    voiding_chart_help_dialog_title: 'Verwenden des Miktionsprotokoll',
    pad_fill_profile_chart_help_dialog_title: 'Verwenden des {pad}-Füllprofils',
    position_chart_help_dialog_title: 'Verwenden des Körperpositionsdiagramms',
    pad_fill_profile_goal_help_dialog_title:
      'Vorgabe für das {pad}-Füllprofil festlegen',
    skin_care_goal_help_dialog_title:
      'Vorgabe für IKM Tragedauer-Management festlegen',
    position_goal_help_dialog_title:
      'Einrichten des Ziels zur Körperneupositionierung',
    temperature_goal_help_dialog_title:
      'Vorgabe für die Umgebungstemperatur des Pods festlegen',
    fall_detection_goal_help_dialog_title:
      'Vorgabe für die Sturzerkennung festlegen',
    invite_user_quick_action_desc_for_home_landing:
      'Laden Sie einen Betreuer ein, dieser Organisation beizutreten',
    archived_successfully: 'Erfolgreich archiviert',
    verification_passed: 'Verifizierung erfolgreich',
    verification_failed: 'Verifizierung fehlgeschlagen',
    verify_error_msg_801:
      'Ihre Einladung ist abgelaufen oder nicht mehr gültig. Um eine weitere Einladung anzufordern, wenden Sie sich an den Administrator der Organisation.',
    verify_error_msg_802:
      'Ihre Einladung ist für diesen Benutzer nicht gültig. Wenn Sie als anderer Benutzer angemeldet waren, bevor Sie diese Einladung angenommen haben. Bitte melden Sie sich ab und versuchen Sie es erneut.',
    verify_error_msg_803: 'Benutzer nicht gefunden.',
    verify_error_msg_804: 'Einladungscode nicht gefunden.',
    verify_error_msg_805:
      'Sie sind bereits Mitglied der Organisation, der Sie beitreten möchten.',
    verify_success_msg: 'Willkommen in der neuen Organisation.',
    verify_error_msg_not_sign_in: `Bitte melden Sie sich an, um der Organisation beizutreten. <br/> Wenn Sie noch kein Konto haben, registrieren Sie sich bitte zuerst.`,
    verify_error_msg_620: 'Der Code ist ungültig oder abgelaufen',
    verify_error_msg_622: `Konnte der Organisation nicht beitreten. Der Einladungscode ist für diese E-Mail-Adresse ungültig.`,
    failed_to_get_chart_data: 'Diagrammdaten konnten nicht gesendet werden.',
    filter: 'Filter',
    please_select_facility_first: 'Bitte wählen Sie zuerst die Einrichtung',
    areas: 'Bereich(e)',
    floors: 'Etage(n)',
    new_area: 'Neuer Bereich',
    manage_areas: 'Bereiche verwalten',
    show_all_facilities: 'Alle Einrichtungen anzeigen',
    show_all_areas: 'Alle Bereiche anzeigen',
    new_area_filter: 'Neuer Bereichsfilter',
    area_filter_name: 'Name des Bereichsfilters',
    area: 'Bereich',
    please_enter_area_filter_name:
      'Bitte geben Sie den Namen des Bereichsfilters ein',
    please_select_facility: 'Bitte wählen Sie die Einrichtung aus',
    please_select_floor_and_room:
      'Bitte wählen Sie die Etage und das Zimmer aus',
    please_select_organisation: 'Bitte wählen Sie die Organisation aus',
    filter_summary: 'Filterzusammenfassung',
    show_patients_from: '{patients} anzeigen von',
    in: 'in',
    and: 'und',
    belonging_to: 'zugehörig zu',
    select_an_area: 'Wählen Sie einen Bereich aus',
    manage_area: 'Bereich verwalten',
    please_select_area_filter: 'Bitte wählen Sie einen Bereichsfilter aus',
    delete_area: 'Bereich löschen',
    keep_in_mind_delete_area: 'Das Löschen des Bereichs ist endgültig. ',
    facility_information: 'Informationen zur Einrichtung',
    floor_information: 'Informationen zur Etage',
    room_information: 'Informationen zum Zimmer',
    number_of_floors: 'Anzahl der Etagen',
    please_enter_number_of_floors: 'Bitte geben Sie die Anzahl der Etagen ein',
    number_of_rooms: 'Anzahl der Zimmer',
    please_enter_number_of_rooms: 'Bitte geben Sie die Anzahl der Zimmer ein',
    add_floor: 'Etage hinzufügen',
    remove_floor: 'Etage entfernen',
    remove_room: 'Zimmer entfernen',
    select_area_warning: `Der Bereich und die Etage können nicht gleichzeitig ausgewählt werden. <br/>Wählen Sie nur eines davon aus.`,
    manage_area_filter: 'Bereichsfilter verwalten',
    no_area: 'Kein Bereich',
    there_are_no_patient_to_manage:
      'Es gibt keine {patients}, die zu verwalten sind.',
    default_themes: 'Standardthemen',
    custom_themes: 'Individuelle Themen',
    background_color: 'Hintergrundfarbe',
    top_navigation_background_color:
      'Hintergrundfarbe des oberen Navigationsbereichs',
    top_nav_text_color: 'Textfarbe des oberen Navigationsbereichs',
    top_nav_active_text_color:
      'Aktive Textfarbe des oberen Navigationsbereichs',
    sidebar_background_color: 'Hintergrundfarbe der Seitenleiste',
    sidebar_active_block_background_color:
      'Aktive Block-Hintergrundfarbe der Seitenleiste',
    sidebar_text_color: 'Textfarbe der Seitenleiste',
    sidbar_active_block_text_color: 'Aktive Block-Textfarbe der Seitenleiste',
    card_title_background_color: 'Hintergrundfarbe des Kartentitels',
    card_title_text_color: 'Textfarbe des Kartentitels',
    card_body_background_color: 'Hintergrundfarbe des Kartentexts',
    card_button_color: 'Farbe der Schaltfläche der Karte',
    room_number: 'Zimmernummer',
    verify_invitation: 'EINLADUNG VERIFIZIEREN',
    well_done: 'Gut gemacht!',
    you_have_updated_the_patient: `Sie haben die Daten des {patient} aktualisiert.`,
    you_have_created_the_patient:
      'Sie haben einen {patient} hinzugefügt, der im Gruppen-Dashboard angezeigt werden kann.',
    tell_me_more: 'Mehr dazu erfahren',
    registered_pods: 'Registrierte Pods',
    registered_nodes: 'Registrierte Knoten',
    select: 'Auswählen',
    start: 'Start',
    end: 'Ende',
    floor_name: 'Name der Etage',
    sign_in_failed: 'Anmeldung fehlgeschlagen',
    skin_care_goal_title: 'Zeit im {pad}',
    time_in_wet_pad: 'Zeit im nassen {pad}',
    'Event Chart': 'Smartz-Ereignisdiagramm',
    account_information: 'Kontoinformationen',
    given_name: 'Vorname',
    surname: 'Nachname',
    please_enter_pod_serial_number:
      'Bitte geben Sie die Seriennummer des Pod ein',
    manufacturer_subscription_code: `Abonnement-Code des Herstellers`,
    remove_node_mac_address: 'MAC-Adresse des Knotens entfernen',
    link_a_node_mac_address: 'Eine MAC-Adresse des Knotens verknüpfen',
    export_data: 'Daten exportieren',
    available_files: 'Verfügbare Dateien',
    export_patient_data_desc:
      'Klicken Sie auf die nachstehende Schaltfläche, um die folgenden Verlaufsdaten zu exportieren:',
    dry_diaper: 'Trockene {pad}',
    wet_diaper: 'Nasse {pad}',
    change_diaper: '{pad} wechseln',
    external_humidity: 'Feuchtigkeit außen',
    smartz_events: 'Smartz<sup>®</sup>-Gesamtübersicht',
    smartz_events_chart_email_content:
      'Das per E-Mail versandte Ereignisdiagramm kann von Ihnen überprüft werden.',
    reposition: 'Neupositionierung',
    fall: 'Sturz',
    cycle: 'Zyklus',
    pad_cycle: '{pad}-Zyklus',
    off_body: 'außerhalb des Körpers',
    pad_status_legend: '{pad}-Status',
    analysing_diaper_legend: '{pad} wird analysiert',
    dry_wet_change_diaper: '{pad} trocken/nass/wechseln',
    pod_status: 'Pod-Status',
    goal_status: 'Zielvorgaben-Status',
    diaper_removed_legend: '{pad} entfernt',
    time_to_change_legend: 'Zeit zum Wechseln',
    out_of_range_legend: 'außerhalb des Bereichs',
    diaper_not_selected: '{pad} nicht ausgewählt',
    duration: 'Dauer',
    small_void: 'Geringe Entleerung',
    medium_void: 'Mittelmäßige Entleerung',
    large_void: 'Umfangreiche Entleerung',
    view_mode: 'Anzeigemodus',
    voids_only: 'nur Entleerungen',
    void_event_size: 'Größe des Entleerungsereignisses',
    pad_start: '{pad}-Start',
    pad_end: '{pad}-Ende',
    exceed_goal_time: 'Zeitliche Vorgabe überschritten',
    reclip: 'erneut anbringen',
    unstable_readings: 'Instabile Messwerte',
    not_selected: 'Nicht ausgewählt',
    analysing: 'Wird analysiert',
    create_organisation: 'Organisation erstellen',
    all_times_are_in: 'Alle Zeiten sind in',
    failed_to_get_goal_settings:
      'Fehler beim Abrufen der festgelegten Zielvorgaben',
    next_steps: 'Nächste Schritte',
    video: 'Video',
    monitor_warning:
      'Monitoring ist nicht verfügbar, da kein Smartz<sup>®</sup>-Pod zugewiesen ist',
    find_further_information: 'Weitere Informationen finden Sie',
    here: 'hier',
    savePatientPodErrMsg: `Die angegebene Pod-Seriennummer ist in dieser Organisation nicht vorhanden.`,
    savePatientNodeErrMsg: `Die angegebene MAC-Adresse des Knotens ist in dieser Organisation nicht vorhanden.`,
    already_registered_desc:
      'Bitte melden Sie sich mit dem Benutzernamen und dem Passwort an, mit denen Sie sich ursprünglich registriert haben.',
    create_account_desc:
      'Bitte geben Sie einen Benutzernamen und ein Passwort ein, um ein Benutzerkonto zu erstellen und auf die Website zuzugreifen.',
    signing_in: 'Anmeldung läuft',
    signing_out: 'Abmeldung läuft',
    welcome: 'Willkommen',
    top: 'Oben',
    facility_or_building: 'Einrichtung/Gebäude',
    keep_at_least_one_facility: 'Behalten Sie mindestens eine Einrichtung bei',
    keep_at_least_one_floor: 'Behalten Sie mindestens eine Etage bei',
    keep_at_least_one_room: 'Behalten Sie mindestens ein Zimmer bei',
    rename: 'Umbenennen',
    domain_name: 'Domainname',
    subscription_code: 'Abonnement-Code',
    events: 'Gesamtübersicht',
    no_pods_text: 'Es sind keine Pods in dieser Organisation registriert.',
    no_nodes_text: 'Es sind keine Knoten in dieser Organisation registriert.',
    confirm_deletion: 'Löschen bestätigen.',
    confirm_archive: 'Archivieren bestätigen',
    account_deletion: 'Löschen des Kontos',
    delete_account_warning:
      'Das Löschen des Benutzerkontos und der personenbezogenen Daten ist endgültig.',
    deletion: 'Löschung',
    restoring_patient: '{patient} wird wiederhergestellt',
    font_family: 'Schriftfamilie',
    font_size: 'Schriftgröße',
    font_color: 'Schriftfarbe',
    main_title: 'Haupttitel',
    title: 'Titel',
    small_title: 'Untertitel',
    body_text: 'Textkörper',
    body_text_small: 'Textkörper (klein)',
    supplementary_text: 'Ergänzender Text',
    primary_text: 'Haupttext',
    regular_text: 'Normaler Text',
    secondary_text: 'Nachrangiger Text',
    placeholder_text: 'Platzhalter-Text',
    top_nav_background: 'Hintergrund des oberen Navigationsbereichs',
    edit_facility_and_floor_and_room:
      'Einrichtung, Etage und Zimmer bearbeiten',
    please_select_buildings: 'Bitte Gebäude auswählen',
    please_select_floors: 'Bitte Etagen auswählen',
    please_select_rooms: 'Bitte Zimmer auswählen',
    facility_setup: 'Festlegen der Einrichtung',
    view_a_patient_by_selecting_from_drop_down_menu:
      'Einen {patient} anzeigen, indem Sie aus dem Dropdown-Menü auswählen.',
    monitoring: 'Monitoring',
    silencing: 'Schweigen',
    fall_detection: 'Sturzerkennung',
    wetness: 'Feuchtigkeit',
    pod: 'Pod',
    diaper: '{pad}',
    time_in_diaper: 'Zeit in {pad}',
    setup_area_filter_desc:
      'Führen Sie diese Schritte aus, um einen neuen Flächenfilter einzurichten.',
    max_time_in_pad: 'Maximale Zeit im {pad}',
    max_time_in_pos: 'Max. Zeit in Position',
    change_in: 'Änderung in',
    not_monitoring: 'Nicht überwachen',
    exceed_allowed_time: 'Überschreitung der zulässigen Zeit',
    exceed_predicted_time: 'Die vorhergesagte Zeit überschreiten',
    Pseudonymized: 'Pseudonymisiert',
    Anonymized: 'Anonymisiert',
    pseudonymized_permission_warning:
      '{patient} pseudonymisierte Berechtigung und {patient} Bearbeitungsberechtigung können nicht gleichzeitig ausgewählt werden. Bitte wählen Sie eine davon aus.',
    anonymized_permission_warning:
      '{patient} pseudonymisierte Berechtigung und {patient} Bearbeitungsberechtigung können nicht gleichzeitig ausgewählt werden. Bitte wählen Sie eine davon aus.',
    please_select_one_product:
      'Bitte wählen Sie eines der Tages- oder Nachtprodukte aus',
    none: 'Keine',
    invitation: 'Einladung',
    has_invited: 'hat eingeladen',
    to_join: 'beitreten',
    invitation_desc:
      'Wenn Sie mit dieser E-Mail-Adresse bereits ein Konto erstellt haben, melden Sie sich bitte an, um teilzunehmen.',
    if_not_please: 'Wenn nicht, bitte',
    accept: 'Akzeptieren',
    decline: 'Ablehnen',
    // The following text is used in German, but not in other languages
    hinweis: 'HINWEIS',
    body_position_goal_for_de: 'Patientenlagerung',
    acceptable_temperature_range: 'akzeptabler Temperaturbereich',
    temperature_alert_off: 'Die Temperaturwarnung ist aus',
    temperature_alert_on:
      'Der Temperaturalarm ist so eingestellt, dass er aktiviert wird, wenn die Temperatur beträgt',
    below: 'unter',
    above: 'über',
    partial_body_repositioning: 'Neupositionierung des Teilkörpers',
    minimum_angle_change: 'minimale Winkeländerung',
    degrees: 'Grad',
    goal_time_exceed: 'Zielzeit überschritten',
    allowed_time_exceed: 'Zulässige Zeit überschritten ',
    predicted_time_exceed: 'Vorhersagezeitüberschreitung',
    safe_time_exceed: 'Sicherheitszeitüberschreitung',
    brief_not_used: '{pad} nicht verwendet',
    monitor_unstable_readings: 'Instabile Messwerte überwachen',
    leakage: 'Leckage',
    new_battery: 'Neuer Akku',
    exceed_safe_time_in_pad: 'Sicherheitszeit in {pad} überschreiten',
    predicted_change_time: 'Prognostizierte Änderungszeit',
    total_time: 'Gesamtzeit',
    exceed_safe_time: 'Sicherheitszeit überschreiten',
    consider_using_smartz_product: 'Smartz-Produkt in Betracht ziehen',
    non_smartz_product_in_use: 'Nicht-smartz-Produkt in Verwendung',
    product_not_selected: 'Produkt nicht ausgewählt',
    assign_smartz_product_to_patient: 'Smartz-Produkt {patient} zuweisen',
    wait_a_moment: 'Einen Moment warten...',
    find_patient: '{patient} finden',
    life: 'Leben',
    flat_battery: 'Batterie leer',
    compliance_notifications: 'Compliance-Benachrichtigungen',
    receive_email_notifications:
      'E-Mail-Benachrichtigungen in Bezug auf Systemnutzung und Compliance erhalten',
    example: 'Beispiel',
    receive_email_desc1:
      'wenn die leeren Pod-Batterien nicht rechtzeitig gewechselt werden, kann dies dazu führen, dass {patient} nicht überwacht werden können',
    receive_email_desc2:
      'wenn das Pflegepersonal die Compliance-Ziele nicht erreicht',
    i_want_to_receive_these_notifications:
      'Ich möchte diese Benachrichtigungen erhalten',
    subscribe_successfully: 'Erfolgreich abonniert',
    unsubscribe_successfully: 'Erfolgreich abbestellt',
    voltage: 'Spannung',
    generate: 'Generieren',
    generate_report: 'Bericht generieren',
    period: 'Zeitraum',
    baseline: 'Baseline',
    trial: 'Testversion',
    generate_in_progress: 'Generieren läuft',
    generate_desc: `Export der Berichtsdaten läuft. Sie werden per E-Mail benachrichtigt, sobald verfügbar. Überprüfen Sie den Fortschritt im Verlaufsmenü.`,
    report_history: 'Berichtsverlauf',
    double_tap: 'Doppeltippen',
    time_period_inconsistent_warning:
      'Der Zeitraum von Periode 1 und Periode 2 sollte konsistent sein',
    trial_reports: 'Testberichte',
    'Trial Reports': 'Testberichte',
    Generate: 'Generieren',
    resend_code: 'Code erneut senden',
    verification_required: 'Überprüfung erforderlich',
    security_step_up: 'Sicherheitssteigerung',
    security_step_up_desc:
      'Wir verifizieren jetzt Ihre Anmeldungen als Folge der Aktualisierung Ihrer Sicherheitsstufe',
    we_have_sent_mfa_code_first_line: `Wir haben einen 6-stelligen Sicherheitscode an Ihre E-Mail-Adresse gesendet`,
    we_have_sent_mfa_code_second_line: `Dieser zusätzliche Schritt zeigt, dass Sie es wirklich sind`,
    enter_secure_code: 'Sicherheitscode eingeben',
    trust_this_browser: 'Diesem Browser vertrauen',
    trust_browser_first_line:
      'Wenn Sie dem Browser auf diesem Computer vertrauen, werden Sie bei der nächsten Anmeldung nicht nach einer zweistufigen Authentifizierung gefragt',
    trust_browser_second_line:
      'Sie sollten niemals "dem Browser vertrauen", wenn Sie einen öffentlichen oder gemeinsam genutzten Computer verwenden. Wir empfehlen Ihnen, nur Browsern zu vertrauen, die Sie regelmäßig verwenden',
    not_now: 'Nicht jetzt',
    browser_can_not_be_trust:
      'Browser können im privaten Modus nicht vertrauenswürdig sein. Wählen Sie „Nicht jetzt“ aus, um mit der Anmeldung fortzufahren ',
    Observation: 'Beobachtung',
    observation: 'Beobachtung',
    common_area: 'Gemeinschaftsbereich',
    qr_code: 'QR-Code',
    please_enter_patient_alias_to_search:
      'Bitte geben Sie den {patient} -Alias für die Suche ein',
    smartz_observations: 'Smartz-Beobachtungen',
    scan_this_code_to_record_and_observation:
      'Diesen Code scannen, um <br /> aufzuzeichnen und zu beobachten',
    need_help: 'Hilfe',
    scan_this_code_to_learn_about_smartz:
      'Diesen Code scannen, um mehr über Smartz zu erfahren',
    summary: 'ZUSAMMENFASSUNG',
    incontinent_event_frquency: 'Häufigkeit von Inkontinenzereignissen',
    bladder_daily: 'Blase (täglich)',
    weekly: 'Wöchentlich',
    bowel_daily: 'Darm (täglich)',
    diaper_utilisation: '{pad} Gebrauch',
    day_pad: 'Tageseinlage',
    usage: 'Verwendung',
    units_during_day: 'Einheiten während des Tages',
    average_fill: 'Durchschnittliche Füllung',
    night_pad: 'Nachteinlage',
    unit_at_night: 'Einheit in der Nacht',
    Period: 'Zeitraum',
    Observations: 'Beobachtungen',
    No_Observations: 'Keine Beobachtungen',
    data_quality: 'Datenqualität',
    pod_out_of_range: 'Pod außerhalb des Bereichs',
    Assessment: 'Beurteilung',
    Day: 'Tag',
    inco_assessment: 'INCO-BEWERTUNG',
    bladder_chart: 'BLASENDIAGRAMM',
    week: 'Woche',
    count: 'Anzahl',
    inco_assessment_email_content:
      'Das per E-Mail versandte Inco-Bewertungsdiagramm kann von Ihnen überprüft werden.',
    observation_chart: 'Beobachtungsdiagramm',
    inco_observation_chart_content:
      'Das per E-Mail versandte Beobachtungsdiagramm kann jetzt von Ihnen überprüft werden.',
    product_name: 'Produktname',
    total_void: 'Total Void',
    utilisation: 'Auslastung',
    node_network_error_msg:
      'Das Dashboard kann derzeit nicht aktualisiert werden, da die Verbindung zum Smartz-Knoten-Netzwerk in Ihrer Einrichtung unterbrochen wurde. Bitte wenden Sie sich an Ihr IT-Support-Team',
    'Inco Assessment': 'INCO-BEWERTUNG',
    'Observation Chart': 'Beobachtungsdiagramm',
    reporting: 'Berichterstattung',
    reporting_page_desc:
      'Die folgenden Informationen über Ihre Organisation werden in der Berichterstattung verwendet',
    baseline_trial_periods: 'BASELINE/ TESTZEITRÄUME',
    rounds_shifts: 'Visiten/ Dienste/ Schichten',
    to_access_reports_go_to: 'Um auf Berichte zuzugreifen, gehen Sie zu',
    portal: 'Portal',
    you_are_about_to_remove_this_item:
      'Sie sind dabei, dieses Element zu entfernen',
    add_round: 'Visite/ Dienst/Schicht hinzufügen',
    edit_round: 'Visite/ Dienst/ Schicht bearbeiten',
    poster_qr_code: 'Poster-QR-Code',
    smartz_id_card: 'Smartz-ID-Karte',
    card_qr_code: 'Karten-QR-Code',
    id_card: 'ID-Karte',
    'Privacy Mode': 'Datenschutzmodus',
    bed_number: 'Bettnummer',
    please_input_bed_number: 'Bitte Bettnummer eingeben',
    range: 'Bereich',
    please_enter_name: 'Bitte Namen eingeben',
    please_select_range: 'Bitte wählen Sie den Bereich aus',
    core_breakup: 'Kernbruch',
    body_repositioning: 'Körperneupositionierung',
    Dashboard: 'Dashboard',
    Organisations: 'Organisationen',
    RolesPermission: 'Rollenberechtigung',
    Network: 'Netzwerk',
    Void: 'Ungültig',
    BodyPosition: 'Körperposition',
    Event: 'Ereignis',
    FillProfile: 'Profil ausfüllen',
    SkinCare: 'Hautpflege',
    Chars: 'Diagramme',
    Goals: 'Ziele',
    Node: 'Knoten',
    Pod: 'Pod',
    Reports: 'Berichte',
    Invite: 'Einladen',
    Private: 'Privat',
    'Inco-assessment': 'Inco-Bewertung',
    application_link_key: 'Anwendungslink-Schlüssel',
    application_link_key_desc: `Dies ist ein Schlüssel, der mit Ihrer Organisation verknüpft ist.`,
    remove_application_link_key_desc: `Entfernen Sie diesen Schlüssel, wenn Sie keine Verbindung herstellen möchten oder können`,
    generate_a_new_one: 'Neu generieren',
    generate_new_application_link_key_warning:
      'Der neu generierte Schlüssel überschreibt den vorherigen Link-Schlüssel',
    delete_application_link_key_warning: `Sie sind dabei, diesen Anwendungslinkschlüssel zu löschen`,
    copied_to_clipboard: 'In Zwischenablage kopiert',
    failed_to_copy: 'Kopieren fehlgeschlagen',
    template: 'Vorlage',
    please_select_a_template: 'Bitte wählen Sie eine Vorlage aus',
    Charts: 'Diagramme',
    choose_permission_template_desc:
      'Wählen Sie eine der folgenden Vorlagenrollen aus, um die Berechtigungen automatisch auszufüllen. Sie können dann die Berechtigungen basierend auf Ihren spezifischen Anforderungen anpassen ',
    Interoperability: 'Interoperabilität',
    comment: 'Kommentar',
    please_enter_comment: 'Bitte geben Sie einen Kommentar ein',
    filter_by_organisation_name: 'nach Name der Organisation filtern',
    physical_activity_chart: 'Diagramm der körperlichen Aktivität',
    stationary: 'stationär',
    sit_stand: 'sitzen/stehen',
    walk: 'gehen',
    jog: 'joggen',
    run: 'rennen',
    physical_activity_chart_content:
      'Das per E-Mail versandte Diagramm der körperlichen Aktivität kann von Ihnen überprüft werden.',
    PhysicalActivity: 'Körperliche Aktivität',
    bed_number_is_not_available: 'Diese Bettnummer ist nicht verfügbar',
    show_archived_patients: 'Archivierte {patients} anzeigen',
    archived: 'Archiviert',
    create_facility: 'Einrichtung erstellen',
    create_new_organisation: 'Eine neue Organisation erstellen',
    add_role_title: 'Rolle hinzufügen',
    create_new_role: 'Eine neue Rolle erstellen',
    create_new_manufacturer: 'Einen neuen Hersteller erstellen',
    create_a_secondary_user: 'Einen sekundären Benutzer hinzufügen',
    please_enter_password: 'Bitte geben Sie das Passwort ein',
    please_enter_password_again: 'Bitte geben Sie das Passwort erneut ein',
    password_rule:
      'Das Passwort muss Groß- und, Kleinbuchstaben, Zahlen und Sonderzeichen enthalten.',
    password_length_rule: 'Das Passwort muss 8 bis 12 Zeichen lang sein.',
    reset_password_successfully: 'Passwort erfolgreich zurückgesetzt',
    invited_user_list: 'Liste der eingeladenen Benutzer',
    basic_settings: 'Grundeinstellungen',
    language: 'Sprache',
    date_time_format: 'Datums- und Zeitformat',
    measure_unit: 'Maßeinheit',
    custom_system_terms: 'Benutzerdefinierte Systembedingungen',
    custom: 'benutzerdefiniert',
    singular: 'Singular',
    plural: 'Plural',
    term: 'Begriff',
    pad_term_not_select_warning:
      'Bitte Pad-Begriff auswählen oder einen benutzerdefinierten Begriff eingeben',
    patient_term_not_select_warning:
      'Bitte patient-Begriff auswählen oder einen benutzerdefinierten Begriff eingeben',
    register_an_installation_id: 'Registrieren Sie eine Installations-ID',
    register_an_installation_id_desc:
      'Registriert die Organisation im Netzwerk mit einer Liste von Knoten und Pods',
    installation_id: 'Installations-ID',
    please_enter_installation_id: 'Bitte geben Sie die Installations-ID ein',
    register_an_installation_id_successful:
      'Installations-ID erfolgreich registriert',
    your_organization_is_already_linked_site:
      'Ihre Organisation ist bereits verknüpft mit',
    you_can: 'Sie können',
    add_a_different_installation_id:
      'Fügen Sie eine andere Installations-ID hinzu',
    remove_this_installation_id: 'Diese Installations-ID entfernen',
    your_organization_is_not_link_organisation:
      'Ihre Organisation ist noch nicht mit dem Smartz-Knoten-Netzwerk verbunden, bitte',
    add_installation_id_desc:
      'Wenn Sie eine Installations-ID hinzufügen, wird diese Organisation mit einem Smartz-Knoten-Netzwerk verknüpft. Dadurch kann diese Organisation auf alle in diesem Netzwerk verfügbaren Knoten und Pods zugreifen.',
    link_another_installation_id_warning:
      'Bitte beachten Sie, dass dadurch die Verbindung zum vorherigen Smartz Node-Netzwerk unterbrochen und ein neues erstellt wird. Einige Knoten und Pods, die Teil einer älteren Installations-ID waren, sind möglicherweise nicht verfügbar.',
    remove_installation_id_warning:
      'Bitte beachten Sie, dass dadurch die Verbindung zum vorherigen Smartz Node-Netzwerk unterbrochen wird. Knoten und Pods, die Teil der aktuellen Installations-ID waren, sind möglicherweise nicht verfügbar.',
    remove_successful: 'Entfernen erfolgreich',
    add_lora_network: 'Ein LoRa-Netzwerk hinzufügen',
    add_a_lora_network: 'Ein LoRa-Netzwerk hinzufügen',
    add_a_different_lora_network: 'Ein anderes LoRa-Netzwerk hinzufügen',
    remove_this_lora_network: 'Dieses LoRa-Netzwerk entfernen',
    application_id: 'Anwendungs-ID',
    please_enter_application_id: 'Bitte geben Sie die Anwendungs-ID ein',
    add_lora_network_successful: 'LoRa-Netzwerk erfolgreich hinzugefügt',
    your_organization_is_already_linked_lora_network:
      'Ihre Organisation ist bereits mit einem LoRa-Netzwerk verknüpft',
    your_organization_is_not_link_lora_network:
      'Ihre Organisation ist noch nicht mit einem LoRa-Netzwerk verknüpft, bitte',
    add_lora_network_desc:
      'Das Hinzufügen eines LoRa-Netzwerks verknüpft diese Organisation mit einem LoRa-Netzwerk. Dies ermöglicht dieser Organisation den Zugriff auf alle in diesem Netzwerk verfügbaren LoRa-Geräte.',
    link_another_lora_network_warning:
      'Bitte beachten Sie, dass dadurch die Verbindung zum vorherigen LoRa-Netzwerk unterbrochen und ein neues erstellt wird. Einige Geräte, die Teil des älteren LoRa-Netzwerks waren, sind möglicherweise nicht verfügbar.',
    remove_lora_network_warning:
      'Bitte beachten Sie, dass dadurch die Verbindung zum LoRa-Netzwerk unterbrochen wird. Geräte, die Teil des aktuellen LoRa-Netzwerks waren, sind möglicherweise nicht verfügbar.',
    'Dashboard Type': 'Dashboard-Typ',
    Carer: 'Betreuer',
    moodle_training: 'Moodle-Training',
    care_plus_dashboard: 'Pflege-Plus-Dashboard',
    take_action: 'Maßnahmen ergreifen',
    task_completion_time: 'Fertigstellungszeit der Aufgabe',
    too_early: 'Zu früh',
    too_late: 'Zu spät',
    ontime: 'Ontime',
    great_work: 'Gut gemacht!',
    pad_change_desc: `{patientAlias} wurde vor {time} geändert`,
    battery_change_desc: `Die Batterie von {patientAlias} wurde vor {time} ausgetauscht`,
    position_change_desc: `Die Position von {patientAlias} wurde vor {time} geändert`,
    fall_event_desc: `Der Sturz von {patientAlias} wurde vor {time} behandelt`,
    days_unit: 'Tag(e)',
    hours_unit: 'Stunde(n)',
    minutes_unit: 'Minute(n)',
    team_work: 'Teamarbeit',
    your_care_team_is_doing_great: 'Ihr Pflegeteam leistet großartige Arbeit',
    a_few_things_to_improve_on:
      'Einige Dinge zur Verbesserung, um Erfolg zu erreichen',
    improve_early_change_desc:
      'Wechseln Sie {pad} nur aufgrund von Systemwarnungen, Fäkalien, Zielvorgaben oder Undichtigkeiten. Vermeiden Sie routinemäßige Wechsel.',
    improve_change_response_time_desc:
      'Überprüfen Sie das Dashboard regelmäßig und handeln Sie umgehend, um {pads} zu ändern, sobald die Symbole Rot anzeigen.',
    improve_goal_response_time_desc:
      'Kümmern Sie sich um {patient}, sobald das Zielsymbol im Abschnitt "Maßnahmen ergreifen" eingeblendet wird.',
    improve_incorrect_clipping_desc:
      'Pod und {Pad} auf Defekte prüfen. Richten Sie den Pod auf die Streifen aus, bevor Sie ihn abschneiden, und warten Sie, bis die grüne Leuchte blinkt. Überprüfen Sie die Trainer-App, um Anweisungen zu erhalten.',
    improve_battery_change_desc:
      'Wechseln Sie die Batterie unverzüglich, sobald dies auf dem Armaturenbrett oder auf dem Pod angezeigt wird.',
    improve_leakage_desc:
      'Wechseln Sie {Pad} sofort bei rotem Symbol. Überprüfen Sie die Größe von {pad} oder die Anwendung von {pad}.',
    improve_frequent_lost_connection_desc:
      'Vermeiden Sie es, den Pod zu verlieren oder zu entsorgen. Pod an neuem {pad} befestigen und sicherstellen, dass {patient} sich innerhalb des Abdeckungsbereichs befindet.',
    low: 'Niedrig',
    medium: 'Mittel',
    high: 'Hoch',
    improve_offline_nodes_desc: `Mehrere Knoten in Ihrem Netzwerk sind derzeit offline. Bitte stellen Sie diese Knoten wieder her, um sicherzustellen, dass das System korrekt funktioniert.`,
    team_support: 'Teamunterstützung',
    team_support_desc1: 'Wahrscheinlicher Abbau der Pflege!',
    team_support_desc2: 'Verbesserungsbedarf',
    team_support_desc3: 'Könnte besser sein',
    team_support_desc4: 'Noch nicht ganz da',
    team_support_desc5: 'In Ordnung, aber könnte besser sein',
    team_support_desc6: 'Zeigt Potenzial',
    team_support_desc7: 'Hat Potenzial',
    team_support_desc8: 'Gute Arbeit, strebe nach Perfektion!',
    team_support_desc9: 'Starke Anstrengung',
    team_support_desc10: 'Beeindruckend',
    team_support_desc11: 'Ausgezeichnet, nicht aufhören!',
    team_support_desc12: 'Fantastisch, mach weiter so!',
    team_support_desc13: 'Erstaunliche Anstrengung! Nicht aufhören',
    team_support_desc14: 'Außergewöhnlich, mach weiter so!',
    team_support_desc15: 'Herausragend, weiter so!',
    insufficient_data_warning:
      'Unzureichende Daten, um Feedback zu geben. Warten auf {count} abgeschlossene Pad-Zyklen',
    demo_org_desc: 'Diese Organisation wird für Demonstrationszwecke verwendet',
    overall_evaluation: 'Gesamteinschätzung',
    demonstration_mode: 'Demonstrationsmodus',
    responsiveness: 'Reaktionsfähigkeit',
    predicted_red: 'Vorhergesagtes Rot',
    predicted_mode: 'Vorhergesagter Modus',
    predicted_time: 'Voraussichtliche Zeit',
    display_time_in_dashboard: 'Uhrzeit im Dashboard anzeigen',
    nurse_call_dashboard: 'Pflegehilferuf-Dashboard',
    organisation_code: 'Organisationscode',
    generate_new: 'Neu generieren',
    check_bin: 'Mülleimer prüfen',
    filter_module_selection_background_color:
      'Hintergrundfarbe der Modulauswahl für Filter',
    filter_module_selection_text_color: 'Textfarbe der Modulauswahl für Filter',
    filter_module_label_color: 'Beschriftungsfarbe des Filtermoduls',
    quick_action_icon_color: 'Schnellaktionssymbolfarbe',
    padding: 'Abstand',
    bottom: 'Unten',
    other: 'Andere',
    peel_and_apply: 'Abziehen und Auftragen',
    calibration_in_progress: 'Kalibrierung läuft',
    apply_sensor: 'Sensor anwenden',
    apply_sensor_desc: 'Warten auf das Anlegen des Sensors',
    record_pod_change: 'Pod-Änderung erfassen',
    pod_change_history: 'Pod-Änderungshistorie',
    change_date: 'Änderungsdatum',
    reason: 'Grund',
    loggged_in_date: 'Anmeldedatum',
    check_connection_status: 'Verbindung prüfen',
    check_connection_desc: 'waiting for pod connection...',
    checking_connection: 'Checking Connection',
    max_sensor: 'Max-Sensor',
    red_threshold: 'Roter Schwellenwert',
    loosely_connected_reclip_pod: 'Lose Verbindung – Reclip-Pod',
    loosely_connected: 'Lose Verbindung',
    sensor: 'Sensor',
    embedded: 'Eingebettet',
    p_n_a: 'PnA',
    change_reason: 'Änderungsgrund',
    please_select_change_reason: 'Bitte wählen Sie den Änderungsgrund aus',
    feedback: 'Feedback',
    pad_weight: '{pad}-Gewicht',
    export_pad_cycle_description:
      'Klicken Sie auf die Schaltfläche unten, um die {pad}-Zyklusdaten zu exportieren',
    pad_weight_data_saved: '{pad}-Gewichtsdaten gespeichert:',
    pad_capacity_reached: '{pad}-Kapazität erreicht',
    actual_weight: 'Tatsächliches Gewicht',
    not_provided: 'Nicht angegeben',
    pad_weight_first_question:
      'War das {pad} voll genug, um gewechselt zu werden?',
    pad_weight_second_question: 'Haben Sie ein tatsächliches Windelgewicht?',
    actual_weight_provided: 'Tatsächliches Gewicht angegeben',
    leakages: 'Leckagen',
    max_time_in_wet_pad: 'Maximale Zeit in nassem {pad}'
  },
  country: 'German',
  language: 'Deutsch',
  abb_name: 'de'
}
